import Navbar from "./components/Navbar";
import Search from "./components/Search";
import Blog from "./components/Blog";
import Footer from "./components/Footer";
import BlogHeader from "./components/BlogHeader";
import { Provider } from "react-redux";
import store from "./redux/store";

function App() {
  return (
    <Provider store={store}>
      <Navbar />
      <Search />
     

      <section
        class="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8"
      >
        <div class="absolute inset-0">
          <div class="bg-white h-1/3 sm:h-2/3"></div>
        </div>
        <div class="relative max-w-7xl mx-auto">
          <BlogHeader />

          <Blog />
        </div>
      </section>

    
    <Footer />
    </Provider>
  );
}

export default App;
